import {
  CreatingAssetFromPageFailed,
  CreatingAssetFromPageRequest,
  CreatingAssetFromPageSucceeded,
  FetchingActivatedWorkSpacesFailed,
  FetchingActivatedWorkSpacesSucceeded,
  FetchingPagesForStoryboardFailed,
  FetchingPagesForStoryboardSucceeded,
  FetchingStoryboardsFailed,
  FetchingStoryboardsRequest,
  FetchingStoryboardsSucceeded,
  FetchPagesForStoryboardRequest,
  Page,
  StoryBoard,
  WorkSpace,
} from "src/types/cleverstory";
import {
  FETCHING_ACTIVATED_WORKSPACES_SUCCEEDED,
  FETCHING_ACTIVATED_WORKSPACES_FAILED,
  FETCHING_STORYBOARDS_SUCCEEDED,
  FETCH_STORYBOARDS_REQUEST,
  FETCH_PAGES_FOR_STORYBOARD_REQUEST,
  FETCHING_PAGES_FOR_STORYBOARD_SUCCEEDED,
  CREATE_ASSET_FROM_STORYBOARD_REQUEST,
  CREATING_ASSET_FROM_STORYBOARD_SUCCEEDED,
  INVALIDATE_CLEVERSTORY_ASSETS,
  FETCHING_STORYBOARDS_FAILED,
  FETCHING_PAGES_FOR_STORYBOARD_FAILED,
  CREATING_ASSET_FROM_STORYBOARD_FAILED,
  WS_ASSET_PROCESSED,
  FETCHING_ACTIVATED_WORKSPACES,
  INVALIDATE_CLEVERSTORY_WORKSPACES,
} from "../actions/actionTypes";
import { UnknownAction } from "redux-saga";
import _ from "lodash";
import { Asset } from "src/types/assets";

interface WorkspaceState {
  loading: boolean;
  error: any;
  item: WorkSpace;
  storyboards: {
    loading: boolean;
    error: any;
    items: StoryboardState[];
    pagination: {
      currentPage: number,
      totalPages: number,
      recordsPerPage: number,
      totalRecordsCount: number,
      hasMoreItems: boolean
    },
  }
}

interface StoryboardState {
  item: StoryBoard;
  pages: PageState
}

interface PageState {
  loading: boolean;
  items: Page[];
  error: any;
  pagination: {
    currentPage: number,
    totalPages: number,
    recordsPerPage: number,
    totalRecordsCount: number,
    hasMoreItems: boolean
  },
}

interface CleverstoryState {
  loading: boolean;
  workspaces: WorkspaceState[];
  error?: any;
  create: {
    [key: string]: CreateAssetFromStoryBoard;
  }
}

interface CreateAssetFromStoryBoard {
  //pageID
  [key: string]: {
    id: string;
    page: Page;
    creating: boolean;
    created: boolean;
    error: any;
    item: Asset;
  };
}
const initialState: CleverstoryState = {
  loading: false,
  workspaces: [],
  error: null,
  create: {}
};

const initialStoryboardsState = {
  loading: false,
  error: null,
  items: [],
  pagination: {
    currentPage: -1,
    totalPages: 0,
    recordsPerPage: 10,
    totalRecordsCount: 0,
    hasMoreItems: false
  },
}

const initialPageState = {
  loading: false,
  error: null,
  items: [],
  pagination: {
    currentPage: -1,
    totalPages: 0,
    recordsPerPage: 10,
    totalRecordsCount: 0,
    hasMoreItems: false
  },
}

export const cleverstoryReducer = (
  state = initialState,
  action: UnknownAction,
) => {
  switch (action.type) {
    case FETCHING_ACTIVATED_WORKSPACES: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }

    case FETCHING_ACTIVATED_WORKSPACES_SUCCEEDED: {
      const { workspaces } = action.payload as FetchingActivatedWorkSpacesSucceeded;

      const workspaceStates = (workspaces || []).map((workspace: WorkSpace) => {
        return {
          loading: false,
          error: null,
          item: workspace,
          storyboards: initialStoryboardsState
        }
      });

      return {
        ...state,
        loading: false,
        workspaces: workspaceStates,
      };
    }

    case FETCHING_ACTIVATED_WORKSPACES_FAILED: {
      const { error } = action.payload as FetchingActivatedWorkSpacesFailed;

      return {
        ...state,
        workspaces: {
          loading: false,
          error: error,
          items: [],
        },
      };
    }

    case FETCH_STORYBOARDS_REQUEST: {
      const { workspace } = action.payload as FetchingStoryboardsRequest;

      const workspaces = (_.get(state, 'workspaces') || []).map(item => {
        const id = _.get(item, 'item.workspace');
        if (id === workspace) {
          return {
            ...item,
            storyboards: {
              ...item.storyboards,
              loading: true,
              error: null,
            }
          }
        }

        return item;
      });

      return {
        ...state,
        workspaces: workspaces
      };
    }

    case FETCHING_STORYBOARDS_SUCCEEDED: {
      const { workspace, response } = action.payload as FetchingStoryboardsSucceeded;

      const workspaces = (_.get(state, 'workspaces') || []).map(item => {
        const id = _.get(item, 'item.workspace');
        if (id === workspace) {

          const existingItems = item.storyboards.items;

          let records = (response.records || []).map(storyboard => {
            return {
              item: storyboard,
              pages: initialPageState,
              create: {}
            } as StoryboardState
          });

          if (response.currentPage > 0) {
            records = [...existingItems, ...records];
          }

          records = _.uniqBy(records, 'item.id');

          return {
            ...item,
            storyboards: {
              ...item.storyboards,
              loading: false,
              items: records,
              pagination: {
                currentPage: response.currentPage,
                totalPages: response.totalPages,
                recordsPerPage: response.recordsPerPage,
                totalRecordsCount: response.totalRecordsCount,
                hasMoreItems: response.currentPage < response.totalPages - 1
              },
            }
          }
        }

        return item;
      });

      return {
        ...state,
        workspaces: workspaces
      };
    }

    case FETCHING_STORYBOARDS_FAILED: {
      const { workspace, error } = action.payload as FetchingStoryboardsFailed;
      const workspaces = (_.get(state, 'workspaces') || []).map(item => {
        const id = _.get(item, 'item.workspace');
        if (id === workspace) {
          return {
            ...item,
            storyboards: {
              ...item.storyboards,
              loading: false,
              error: error
            }
          }
        }

        return item;
      });

      return {
        ...state,
        workspaces: workspaces
      };
    }

    case FETCH_PAGES_FOR_STORYBOARD_REQUEST: {
      const { workspace, storyboard } = action.payload as FetchPagesForStoryboardRequest;
      const workspaces = (_.get(state, 'workspaces') || []).map((item: WorkspaceState) => {
        const id = _.get(item, 'item.workspace');
        if (id === workspace) {
          const storyboards = (item.storyboards?.items || []).map(storyboardItem => {
            if (storyboardItem.item?.id === storyboard) {
              return {
                ...storyboardItem,
                pages: {
                  ...initialPageState,
                  loading: true
                }
              }
            }

            return storyboardItem;
          });

          return {
            ...item,
            storyboards: {
              ...item.storyboards,
              items: storyboards
            }
          }
        }

        return item;
      });

      return {
        ...state,
        workspaces: workspaces
      };
    }

    case FETCHING_PAGES_FOR_STORYBOARD_SUCCEEDED: {
      const { workspace, storyboard, response } = action.payload as FetchingPagesForStoryboardSucceeded;

      const workspaces = (_.get(state, 'workspaces') || []).map((item: WorkspaceState) => {
        const id = _.get(item, 'item.workspace');
        if (id === workspace) {
          const storyboards = (item.storyboards?.items || []).map(storyboardItem => {
            if (storyboardItem.item?.id === storyboard) {

              const existingPages = _.get(storyboardItem, 'pages.items', []);

              let records = response.records;
              if (response.currentPage > 0) {
                records = [...existingPages, ...records];
              }

              records = _.uniqBy(records, 'id');

              return {
                ...storyboardItem,
                pages: {
                  ...initialPageState,
                  loading: false,
                  items: records,
                  pagination: {
                    currentPage: response.currentPage,
                    totalPages: response.totalPages,
                    recordsPerPage: response.recordsPerPage,
                    totalRecordsCount: response.totalRecordsCount,
                    hasMoreItems: response.currentPage < response.totalPages - 1
                  },
                }
              }
            }

            return storyboardItem;
          });

          return {
            ...item,
            storyboards: {
              ...item.storyboards,
              items: storyboards
            }
          }
        }

        return item;
      });

      return {
        ...state,
        workspaces: workspaces
      };
    }

    case FETCHING_PAGES_FOR_STORYBOARD_FAILED: {
      const { workspace, storyboard, error } = action.payload as FetchingPagesForStoryboardFailed;

      const workspaces = (_.get(state, 'workspaces') || []).map((item: WorkspaceState) => {
        const id = _.get(item, 'item.workspace');
        if (id === workspace) {
          const storyboards = (item.storyboards?.items || []).map(storyboardItem => {
            if (storyboardItem.item?.id === storyboard) {
              return {
                ...storyboardItem,
                pages: {
                  ...initialPageState,
                  loading: false,
                  error: error
                }
              }
            }

            return storyboardItem;
          });

          return {
            ...item,
            storyboards: {
              ...item.storyboards,
              items: storyboards
            }
          }
        }

        return item;
      });

      return {
        ...state,
        workspaces: workspaces
      };
    }

    case CREATE_ASSET_FROM_STORYBOARD_REQUEST: {
      const { page } = action.payload as CreatingAssetFromPageRequest;

      return {
        ...state,
        create: {
          ...state.create,
          [page.id]: {
            id: page.id,
            page: page,
            creating: true,
            created: false,
            error: null,
            item: null
          }
        }
      };
    }

    case CREATING_ASSET_FROM_STORYBOARD_SUCCEEDED: {
      const { pageId, asset } = action.payload as CreatingAssetFromPageSucceeded;

      return {
        ...state,
        create: {
          ...state.create,
          [pageId]: {
            ...state.create[pageId],
            creating: false,
            created: true,
            error: null,
            item: {
              ...state.create[pageId].item,
              ...asset
            }
          }
        }
      };
    }

    case CREATING_ASSET_FROM_STORYBOARD_FAILED: {
      const { pageId, error } = action.payload as CreatingAssetFromPageFailed;

      return {
        ...state,
        create: {
          ...state.create,
          [pageId]: {
            ...state.create[pageId],
            creating: false,
            created: true,
            error: error,
          }
        }
      };
    }

    case WS_ASSET_PROCESSED: {
      const asset = action.payload as Asset;
      const id = asset.id;

      const pages = { ...state.create };
      _.keys(state.create).forEach(key => {
        const pageState = pages[key] as CreateAssetFromStoryBoard;
        if (pageState.created && pageState.item!.id === id) {
          const updatePage  = {
            ...pageState,
          }

          pages[key] =  _.set(updatePage, 'item', asset);
        }
      });

      return {
        ...state,
        create: pages
      };
    }

    case INVALIDATE_CLEVERSTORY_ASSETS: {
      const id = action.payload as string;

      return {
        ...state,
        create: _.omit(state.create, id)
      };
    }

    case INVALIDATE_CLEVERSTORY_WORKSPACES: {
      return {
        ...state,
        workspaces: []
      };
    }
    default:
      return state;
  }
};
